<template>
    <div class="service-section pt-100 pb-70 service-details">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 pb-30">
                    <div class="forum-details desk-pad-right-40">
                        <h2>{{ $t('services.details.serviceOne.title') }}</h2>
                        <p>{{ $t('services.details.serviceOne.intro') }}</p>
                        <p>{{ $t('services.details.serviceOne.body') }}</p>
                        <img v-lazy="$ossImg(localizedImg('service/service-1-1.jpg'))" alt="service">
                       
                        <div class="row">
                            <h3>{{ $t('services.details.serviceOne.highlightTitle') }}</h3>
                            <p>{{ $t('services.details.serviceOne.highlight') }}</p>
                            <div class="col-12 col-sm-6">
                                <img v-lazy="$ossImg(localizedImg('service/service-1-2.jpg'))" alt="service">
                            </div>
                            <div class="col-12 col-sm-6">
                                <img v-lazy="$ossImg(localizedImg('service/service-1-3.jpg'))" alt="service">
                            </div>
                        </div>
                       
                    </div>
                </div>
              
            </div>
        </div>
    </div>
</template>

<script>
import localizedImageMixin from '@/mixins/localizedImageMixin'

export default {
    name: 'ServicesDetails',
    mixins: [localizedImageMixin]
}
</script>
